import React from "react";

export default function FacialRecognition() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-white px-2 md:px-8 pt-20"
         style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/FR-Background2.png)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }} 
        >
      {/* Side-by-Side Section */}
      <div className="flex-grow flex flex-col md:flex-row items-center justify-center gap-12 px-8 pt-20">
        {/* Video Section */}
        <div className="w-full md:w-1/2">
          <video 
            className="w-full rounded-2xl shadow-lg object-cover" 
            controls 
            autoPlay 
            muted 
            loop
          >
            <source src={`${process.env.PUBLIC_URL}/FR-Video.mp4`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Text Content Section */}
        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-full md:w-1/2">
          <h1 className="text-4xl font-bold text-purple-400 mb-6">Facial Recognition</h1>
          <p className="text-gray-300 leading-relaxed text-lg my-6">
            Developed a high-accuracy facial recognition system using advanced CNN models, achieving 98.76% validation accuracy.
          </p>
          <ul className="list-disc list-outside pl-6 text-gray-300 leading-relaxed text-md md:text-lg space-y-4">
            <li>Model Development: Trained custom CNNs using TensorFlow and Keras.</li>
            <li>Face Detection: Utilized OpenCV, dlib, and face_recognition libraries.</li>
            <li>System Integration: Built a modular architecture for real-time detection.</li>
            <li>Deployment: Resolved complex dependency issues for smooth execution.</li>
          </ul>
          <p className="text-gray-300 leading-relaxed text-lg mt-6">
            Achieved real-time performance, ideal for security and authentication use cases.
          </p>
        </div>
      </div>
    </div>
  );
}